import { Post } from "@/data/blog-posts"

import { CardPost } from "../card-post"

interface RelatedPostsProps {
  posts: Post[]
}

export function RelatedPosts({ posts }: RelatedPostsProps) {
  return (
    <div>
      <h2 className="mb-6 text-2xl font-bold text-foreground">Posts Relacionados</h2>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {posts.map((post) => (
          <CardPost key={post.slug}  post={post} />
        ))}
      </div>
    </div>
  )
}
